/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import PlanogramScreen from '@/screens/setting/planogram/PlanogramScreen';
import PlanogramDetailScreen from '@/screens/setting/planogram/PlanogramDetailScreen';
import PlanogramFormScreen from '@/screens/setting/planogram/PlanogramFormScreen';

const Stack = createStackNavigator();

const PlanogramNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('PlanogramFormScreen', {
        titleScreen: props.route.params.name,
        name: props.route.params.name,
        id: props.route.params.id,
      });
    } else {
      props.navigation.replace('PlanogramFormScreen');
    }
  };

  return (
    <Stack.Navigator
      initialRouteName="PlanogramScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="PlanogramScreen"
        component={PlanogramScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by PlanogramScreen so
          // Add goes through openChild and preserves the list on return.
          title: setTitleHeader('Planogram'),
        })}
      />
      <Stack.Screen
        name="PlanogramDetailScreen"
        component={PlanogramDetailScreen}
        options={(props) => {
          const hasAccess = hasNoAccess([
            'vice_president_finance',
            'budget_controller',
            'finance_head',
            'tax_support',
            'billing_supervisor',
            'general_manager_marketing',
            'marketing_support',
          ]);
          const route = props.route;
          let title = 'Planogram Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() to the list (not pop) so back survives a browser
                // refresh, where the list isn't in the fresh stack.
                onPress={() => props.navigation.navigate('PlanogramScreen')}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : hasAccess ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ) : (
                false
              ),
          };
        }}
      />
      <Stack.Screen
        name="PlanogramFormScreen"
        component={PlanogramFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Planogram';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit ? 'PlanogramDetailScreen' : 'PlanogramScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default PlanogramNavigator;
